import { createExternalStore } from './createExternalStore';

/**
 * Lead-management client-only state, migrated off Apollo `makeVar` reactive vars.
 * Read reactively via `useValue()`; written imperatively via `set()`.
 */

/**
 * Conversation whose renter profile was just requested. Drives the "Profile requested" state in the
 * screening-criteria cells until the lead-management table refetches.
 */
export const leadManagementShowProfileRequestedForConversationIdStore = createExternalStore('');

/**
 * Signals RenterDetailsModal which section to scroll to on open. The modal resets it to '' once it
 * has scrolled.
 */
export const leadManagementRenterDetailsSectionToScrollToStore = createExternalStore<
  'latestContact' | 'notepad' | 'renterDetailsHeader' | 'renterProfile' | ''
>('');
